import DemographicsForm from './DemographicsForm'
import FormUtils from '../../utils/FormUtils'
import ModalComponent from '../common/Modal/Modal.component'
import React from 'react'
import customerStore from '../../datastore/CustomerStore'
import { observer } from 'mobx-react'
import styled from '@emotion/styled'
import theme from '../../global/theme'

const Wrapper = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid ${theme.colors.borderColor};
`

const SectionLabel = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: ${theme.colors.textDark};
  margin-bottom: 10px;
`

const Pill = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${theme.colors.primary};
  color: #fff;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: opacity 0.15s;
  &:hover {
    opacity: 0.85;
  }
`

const PillLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.75;
  pointer-events: none;
`

const PillDivider = styled.span`
  opacity: 0.4;
  margin: 0 2px;
  pointer-events: none;
`

const FormWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: stretch;
`

const SidebarYourInfoPill: React.FC = () => {
  const [open, setOpen] = React.useState(false)

  const chipLabel = [
    customerStore.postalCode,
    customerStore.dateOfBirth
      ? String(FormUtils.getAge(customerStore.dateOfBirth))
      : '',
    customerStore.gender
      ? customerStore.gender.charAt(0).toUpperCase() +
        customerStore.gender.slice(1)
      : '',
  ]
    .filter(Boolean)
    .join(' · ')

  return (
    <Wrapper>
      <SectionLabel>Showing plans for</SectionLabel>
      <Pill id='yourInfoSidebarPill' onClick={() => setOpen(true)}>
        <PillLabel>Your Info</PillLabel>
        {chipLabel && (
          <>
            <PillDivider>|</PillDivider>
            <span style={{ pointerEvents: 'none' }}>{chipLabel}</span>
          </>
        )}
      </Pill>

      {open && (
        <ModalComponent
          setOpen={setOpen}
          width={480}
          description='Confirm your details'
          zIndex={10000}
        >
          <FormWrapper>
            <DemographicsForm
              onSuccess={() => setOpen(false)}
              heading='Confirm your details'
              subheaderText='Please ensure your information is accurate to receive the most relevant quotes.'
              showPhone
              showEmail
              submitId='updatePlansSidebar'
            />
          </FormWrapper>
        </ModalComponent>
      )}
    </Wrapper>
  )
}

export default observer(SidebarYourInfoPill)
